// extracted by mini-css-extract-plugin
var _1 = "s7Wp0mnkT592zMfZa8Kz";
export { _1 as "grid" }
